import groq from 'groq'

export const getStaticPageQuery = groq`
  *[_type == "staticPage" && language == $language && path == $path][0] {
    title,
    header,
    metaDescription,
    content,
  }
`

export const faqsQuery = groq`
*[_type == 'staticPage' && path == '/faq' && language == $language && !(_id in path("drafts.**"))]{
  title,
  header,
  metaDescription,
  content,
  'faqs': coalesce(listOfContents[]{
    'question': heading,
    'answer': description,
    'key': _key
  }, [])
}[0]
`
